import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=0ff0ced2&scoped=true"
import script from "./ChangeDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&id=0ff0ced2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0ced2",
  null
  
)

export default component.exports